import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import data from "../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Toolbar,
    Item,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import "jspdf-autotable";
import "../css/omstyle.css";
const selectionFilter = ['selected', '=', true];
let dataGrid;

const ViewTransactionHistoryDetails = (props) => {
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const Ompricelevel = props.oidc.user.profile.OMDEFAULTPRICELEVEL;
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);

    }, [setLoadPanelVisible]);
    const [showEmployeeInfo, setShowEmployeeInfo] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    const [currentLayout, setCurrentLayout]= useState("Default");

    const detailDataGrid = useRef(null);
    const getSelectedRows = () => {
        if (detailDataGrid && detailDataGrid.current) {
            return detailDataGrid.current.instance().getSelectedRowKeys();
        }
        return [];
    };
    const position = { of: '#accordion-containe2' };
    var permissions = props.ReceiptReducer.rolePermissions;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "6a4a2946-680f-4925-9af3-bbde3f8aad6d";
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const fetchData = (accessToken, selectedTab) => {
        const resultData = createStore({
            key: 'key',
            loadParams:
            {
                headerId: function () {
                    return props.headerRowId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetViewDetailItemsByHeader}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.OM.UpdateItem}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
            onModified: (method, ajaxOptions) => {
                notify(
                    {
                        message: 'Record has been updated successfully.',
                        width: 100,
                    },
                    'success',
                    3000,
                );
                const resultData = fetchData(accessToken, props.selectedTab);
                detailDataGrid.current.instance().option("dataSource", resultData);
            },
            errorHandler: (error) => {
                notify(
                    {
                        message: 'Error: Something went wrong try again',
                        width: 100,
                    },
                    'error',
                    3000,
                );
                console.error('Error:', error); // Log the error to the console
            },
        });
        return resultData;
    }
    useEffect(() => {
        const resultData = fetchData(accessToken, props.selectedTab);
        detailDataGrid.current.instance().option("dataSource", resultData);
    }, []);

    return (
        <div >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={showIndicator}
                shading={shading}
                showPane={showPane}
                hideOnOutsideClick={hideOnOutsideClick}
            />
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                allowColumnReordering={true}
                allowColumnResizing={true}
                //  onInitialized={onInitialized}
                ref={detailDataGrid}
                showBorders={true}
                hoverStateEnabled={true}
                className={props.searchPanelStatus ? "DetailsItemGirdOpenState" : "DetailsItemGirdCloseState"}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
               
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>

                <Export enabled={true} allowExportSelectedData={true} />

                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
               

                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter enabled={true} visible={false} />
                <GroupPanel visible={false} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="selected" dataType="boolean" caption=""
                 fixed={true}  allowReordering={false} allowResizing={false} 
                >
                </Column>
                <Column
                    dataField="quantityorder"
                    dataType="number"
                    caption="Ordered"
                    fixed={true}  allowReordering={false} allowResizing={false} 
                ></Column>


                <Column dataField="warehouse" caption='Warehouse' allowEditing={false} ></Column>
                <Column dataField="itemCode" caption='Item' allowEditing={false} ></Column>
                <Column dataField="description_1" caption='Description' allowEditing={false} ></Column>
                <Column dataField="lotcode" caption='Lot' allowEditing={false} ></Column>
                <Column dataField="lotDescription1" caption='Lot Description' allowEditing={false} ></Column>
                <Column dataField="classCode" caption='Item Class Code' allowEditing={false} ></Column>
                <Column dataField="subClassCode" caption='Item SubClass Code' allowEditing={false} ></Column>
                <Column dataField="status" caption='Item Status' allowEditing={false} ></Column>
                <Column dataField="lotstatus" caption='Lot Status' allowEditing={false} ></Column>
                <Column dataField="available" caption='Available Qty' allowEditing={false} ></Column>
                <Column dataField="netavailable" caption='Net Available Qty' allowEditing={false} ></Column>
                <Column dataField="unitPriceItem" caption='Unit Price' allowEditing={false} ></Column>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(ViewTransactionHistoryDetails);